<script>
  import Checkbox from '../Checkbox.svelte';
  import Modal from '../Modal.svelte';

  export let printOptions = [];
  export let printOption = 'digital transfer';
  export let changeFn = undefined;

  let showEmbroideryModal = false;

  function handlePrintOptionSelect(event) {
    // Turn off all checkboxes
    const checkboxes = document.querySelectorAll('.print-option input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    // Turn on the selected checkbox
    const selectedCheckbox = event.target;
    selectedCheckbox.checked = true;
    const selectedOption = event.target.value;
    // Set the selected option to the printOption variable
    printOption = selectedOption;
    if (changeFn) {
      changeFn(selectedOption);
    }
  }
</script>

<Modal show={showEmbroideryModal} allowClose={true}>
  <h2 class="heading">Embroidery Print Option</h2>
  <p class="embroidery-text">
    There is a one-time setup fee of <b>$50.00</b> for new embroidered logos. This fee is charged only once per logo.
    <br /><br />
    Setup is free for orders over $1,000.00.
    <br /><br />
    If you have ordered embroidery before, you will <b>NOT</b> be charged this fee again.
    <br /><br />
    If you have any questions, please <a href="/contact">contact us</a>.
    <br /><br />
    Any applicable embroidery setup fees will be invoiced separately after your order is placed.
  </p>
</Modal>

<div class="print-type-options">
  <span class="label">Print Type</span>
  <div class="print-options-grid" style={`grid-template-columns:${printOptions.length} ;`}>
    {#each printOptions as option}
      <div class="print-option">
        <Checkbox
          label={option.PrintOption.name}
          changeFn={handlePrintOptionSelect}
          checked={printOption === option.PrintOption.name}
          value={option.PrintOption.name}
        />
        {#if option.PrintOption.name === 'embroidery'}
          <!-- svelte-ignore a11y-click-events-have-key-events -->
          <div class="print-option-info" on:click={() => (showEmbroideryModal = true)}>
            <img class="info-icon" src="img/icons/info.svg" alt="" />
          </div>
        {/if}
      </div>
    {/each}
  </div>
</div>

<style>
  .label {
    font-weight: bold;
    color: #666;
    letter-spacing: 1.5px;
    font-size: 1.2rem;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    display: block;
  }
  .print-type-options {
    margin-bottom: 2rem;
  }

  .print-options-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }

  .print-option {
    text-transform: capitalize;
    display: flex;
  }

  .print-option-info {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .info-icon {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.5rem;
  }

  .heading {
    font-family: 'Oswald', sans-serif;
    font-size: 2.4rem;
    color: #fe5900;
    margin-bottom: 1rem;
    text-align: center;
  }
</style>
